import React from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../services/authService';

/**
 * Dashboard Resolver Component
 * Redirects to appropriate dashboard based on user role
 */
const DashboardResolver = () => {
  const role = authService.getUserRole();

  console.log('🔍 Resolving dashboard for role:', role);

  // Route based on role
  switch (role) {
    case 'administrator':
      return <Navigate to="/admin-dashboard" replace />;
    case 'caregiver':
      return <Navigate to="/caregiver-dashboard" replace />;
    case 'physiotherapist':
      return <Navigate to="/physiotherapist-dashboard" replace />;
    case 'kitchen':
      return <Navigate to="/kitchen-dashboard" replace />;
    case 'nurse':
    case 'caretaker':
      return <Navigate to="/nurse-dashboard" replace />;
    default:
      // Default to nurse dashboard if role is not recognized
      console.warn('⚠️ Unknown role, defaulting to nurse dashboard');
      return <Navigate to="/nurse-dashboard" replace />;
  }
};

export default DashboardResolver;
